const Map = () => {
    return (
        <iframe className="map" src="https://map.aqarchain.io/" width={"100%"} style={{ height: "calc(100vh-100px)" }} frameborder="0"></iframe>
    )
}

export default Map
